import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FilterListIcon from 'mdi-react/FilterListIcon';

class MatTableFilterButton extends React.Component {
  static propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    onTextSort: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired
  };

  state = {
    anchorEl: null,
  };

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleSort = property => (event) => {
    const { onRequestSort } = this.props;
    onRequestSort(event, property);
    this.handleClose();
  };

  handleTextSort = (event) => {
    const { onTextSort } = this.props;
    onTextSort(event);
  };

  render() {
    const { t } = this.props;
    const { anchorEl } = this.state;

    return (
      <div>
        <div className="material-table__toolbar-search">
          {t('forms.search')}: <input type="text" name="filter" onChange={e => this.handleTextSort(e)} />
        </div>
        <IconButton
          className="material-table__toolbar-button"
          aria-owns={anchorEl ? 'simple-menu' : null}
          aria-haspopup="true"
          onClick={this.handleClick}
        >
          <FilterListIcon />
        </IconButton>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={this.handleClose}
          className="material-table__filter-menu"
        >
          <MenuItem onClick={this.handleSort('code')} className="material-table__filter-menu-item">
            {t('forms.code')}
          </MenuItem>
          <MenuItem onClick={this.handleSort('name')} className="material-table__filter-menu-item">
            {t('forms.name')}
          </MenuItem>
        </Menu>
      </div>
    );
  }
}

export default withTranslation('common')(MatTableFilterButton);